import { Yup } from "components/DynamicForm/utils";
import { DUA_STATUS, DYNAMIC_TYPE_INPUT_TYPE, MOVEMENT_STATUS, SELECT_INPUT_TYPE, TRANSPORTAION_KEYS } from "utils/Constants";

const form = {
    sections: [{
        fields: [
            [
                {
                    "type": SELECT_INPUT_TYPE,
                    "name": "tipo_transporte",
                    "validation": Yup.string().required(),
                    "label": "Tipo File",
                    "options": TRANSPORTAION_KEYS,
                    "disabledOnEdit": true,
                    "sizing": {
                        "sm": 3
                    }
                },
                {
                    "type": "text",
                    "name": "secuencia",
                    "label": "Secuencia",
                    "disabled": true,
                    "sizing": {
                        "sm": 6
                    }
                },
            ],
            [
                {
                    "type": "country",
                    "name": "origin",
                    "validation": Yup.string().required(),
                    "label": "Pais Origen"
                },
                {
                    "type": "text",
                    "validation": Yup.string().required(),
                    "name": "puerto_carga",
                    "label": "Puerto Cargar"
                },
                {
                    "type": "country",
                    "validation": Yup.string().required(),
                    "name": "destino",
                    "label": "Pais Destino"
                },
                {
                    "type": "text",
                    "validation": Yup.string().required(),
                    "name": "puerto_descarga",
                    "label": "Puerto Descarga"
                },
            ],
            [
                {
                    "type": "text",
                    "name": "agente_transporte",
                    "label": "Agente Naviero / Aerolinea"
                },
                {
                    "type": "text",
                    "name": "bl_guia",
                    "label": "BL / Guia"
                },
            ],
            [
                {
                    "type": "textarea",
                    "validation": Yup.string().required(),
                    "name": "commotity",
                    "label": "Commotity"
                }
            ],
            [
                {
                    "type": DYNAMIC_TYPE_INPUT_TYPE,
                    "name": "measures",
                    "label": "Medidas",
                    "validation": Yup.string().required(),
                    "dynamicType": "text",
                    "options": {
                        "cm": "cm",
                        "inch": "inch",
                    },
                    "defaultOption": "cm"
                },
                {
                    "type": DYNAMIC_TYPE_INPUT_TYPE,
                    "validation": Yup.string().required(),
                    "dynamicType": "number",
                    "name": "weigth",
                    "min": "0",
                    "step": ".01",
                    "label": "Peso",
                    "options": {
                        "lbs": "Lbs",
                        "kg": "Kg",
                    },
                    "defaultOption": "lbs"
                },
                {
                    "type": DYNAMIC_TYPE_INPUT_TYPE,
                    "name": "vweigth",
                    "validation": Yup.string().required(),
                    "dynamicType": "number",
                    "min": "0",
                    "step": ".01",
                    "label": "Peso Volumentrico",
                    "options": {
                        "ft³": "ft³",
                        "vlb": "Vlb",
                    },
                    "defaultOption": "ft³"
                },
            ],
            [
                {
                    "type": "date",
                    "name": "etd",
                    "label": "ETD"
                },
                {
                    "type": "date",
                    "name": "eta",
                    "label": "ETA"
                },
            ],
            [
                {
                    "type": "text",
                    "name": "tipo_despacho",
                    "label": "Tipo Despacho"
                },
                {
                    "type": "text",
                    "name": "almacen_fiscal",
                    "label": "Almacen Fiscal"
                },
            ],
            [
                {
                    "type": "text",
                    "name": "recibo",
                    "label": "Recibo"
                },
                {
                    "type": SELECT_INPUT_TYPE,
                    "name": "semaforo",
                    "label": "Semaforo",
                    "options": DUA_STATUS
                },
            ],
            [
                {
                    "type": "text",
                    "name": "dua",
                    "label": "DUA"
                },
                {
                    "type": "date",
                    "name": "fecha_dua",
                    "label": "Fecha Dua"
                },
            ],
            [
                {
                    "type": "text",
                    "name": "transporte_interno",
                    "label": "Transporte Interno"
                },
                {
                    "type": "text",
                    "name": "tramitador",
                    "label": "Tramitador"
                },
            ],
            [
                {
                    "type": SELECT_INPUT_TYPE,
                    "name": "status",
                    "label": "Estado Paquete",
                    "options": MOVEMENT_STATUS,
                    "sizing": {
                        "sm": 4
                    }
                },
            ]
        ]
    }]
};

export default form;